import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { EmployeeSchedule } from '../models/EmployeeSchedule'
import { EmployeeScheduleForm } from '../forms/EmployeeScheduleForm'
import { EmployeeScheduleFilter } from '../filters/EmployeeScheduleFilter'
import { EmployeeScheduleService } from '../services/EmployeeScheduleService'

export const useEmployeeScheduleStore: KsStoreHook<EmployeeSchedule, EmployeeScheduleForm, EmployeeScheduleFilter> = createKsStore({
  id: 'employeeSchedules',
  modelClass: EmployeeSchedule,
  formClass: EmployeeScheduleForm,
  filterClass: EmployeeScheduleFilter,
  service: EmployeeScheduleService,
  labelField: (item) => item.templateName || `Planning #${item.id}`,
  signalREventName: 'EmployeeScheduleModel'
})
